import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M.14.834A.564.564 0 0 1 0 .468C0 .338.047.227.14.136A.486.486 0 0 1 .494 0c.14 0 .258.045.352.136L6 5.122 11.155.136A.486.486 0 0 1 11.507 0a.47.47 0 0 1 .352.145c.094.096.141.21.141.34 0 .13-.047.247-.14.349L6 6.5.14.834z"
    }, null, -1)
  ])))
}
export default { render: render }